import React, { useState, useEffect } from 'react';
import { updateUserRoles, listRoles } from '../../api/admin';

export default function ManageRolesModal({ user, onClose, onUpdate }) {
  const [selectedRoles, setSelectedRoles] = useState([...user.roles]);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    loadRoles();
  }, []);

  const loadRoles = async () => {
    try {
      const data = await listRoles();
      setAvailableRoles(data.roles || []);
    } catch (err) {
      console.error('Failed to load roles:', err);
      setError('Failed to load available roles');
    }
  };

  const handleToggleRole = (roleName) => {
    if (selectedRoles.includes(roleName)) {
      setSelectedRoles(selectedRoles.filter((r) => r !== roleName));
    } else {
      setSelectedRoles([...selectedRoles, roleName]);
    }
  };

  const handleSave = async () => {
    if (selectedRoles.length === 0) {
      setError('At least one role must be selected');
      return;
    }

    try {
      setLoading(true);
      setError('');
      await updateUserRoles(user.id, selectedRoles);
      onUpdate(); // Notify parent to refresh
      onClose();
    } catch (err) {
      console.error('Failed to update roles:', err);
      setError(err.message || 'Failed to update roles');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="modal-overlay" onClick={onClose}></div>
      <div className="modal modal-small">
        <div className="modal-header">
          <h3>Manage Roles - {user.username}</h3>
          <button className="btn-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="modal-body">
          {error && <div className="error">{error}</div>}

          <p>Select roles for this user:</p>

          <div className="role-checkboxes">
            {availableRoles.map((role) => (
              <label key={role.name} className="checkbox-label">
                <input
                  type="checkbox"
                  checked={selectedRoles.includes(role.name)}
                  onChange={() => handleToggleRole(role.name)}
                />
                <span>{role.name}</span>
                <small>{role.description}</small>
              </label>
            ))}
          </div>

          <div className="modal-actions">
            <button className="btn-primary" onClick={handleSave} disabled={loading}>
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
            <button className="btn-secondary" onClick={onClose} disabled={loading}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
